module.exports = __webpack_public_path__ + "img/Grenada.9daeb92e.svg";